import { CsChatUnreadProvider } from "@repo/cs-chat/CsChatUnreadProvider";
import type { FC, ReactNode } from "react";
import { useWorkspacePagesPath } from "src/hooks/useWorkspacePagesPath";
import { useCreateCsChatJwtToken } from "./useCreateCsChatJwtToken";
import { csChatWorkerBaseUrl } from "./workerUrl";

export const LyraCsChatUnreadProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const pagesPath = useWorkspacePagesPath();
  const createToken = useCreateCsChatJwtToken();

  return (
    <CsChatUnreadProvider
      createToken={createToken}
      workerBaseUrl={csChatWorkerBaseUrl}
      chatPagePathname={pagesPath.support.$url().pathname}
    >
      {children}
    </CsChatUnreadProvider>
  );
};
